import { useEffect, useState } from 'react';
import { collection, onSnapshot, query } from 'firebase/firestore';
import { db } from '../config/firebase';

const useFondosFci = () => {
    const [fondos, setFondos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const q = query(collection(db, 'fondosFci'));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs
                .map(d => ({ id: d.id, ...d.data() }))
                .filter(f => f.active !== false)
                .sort((a, b) => (a.nombre || '').localeCompare(b.nombre || '', 'es', { sensitivity: 'base' }));
            setFondos(data);
            setIsLoading(false);
        }, (error) => {
            console.error('Error cargando fondosFci:', error);
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, []);

    return { fondos, isLoading };
};

export default useFondosFci;
